var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"close"}},[(_vm.isOpen)?_c('div',{class:_vm.alertClass,attrs:{"role":"alert"}},[_c('div',{staticClass:"f-alert-content mr-auto flex flex-align-items-center"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }